// i18n 配置类型定义
// 注意：SupportedLanguage 类型在 stores/appStore.ts 中定义，这里重新导出
import type { SupportedLanguage } from '../stores/appStore';
export type { SupportedLanguage };

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = ['zh-CN', 'en-US', 'zh-TW'];

export const DEFAULT_LANGUAGE: SupportedLanguage = 'zh-CN';

export const LANGUAGE_LABELS: Record<SupportedLanguage, string> = {
  'zh-CN': '简体中文',
  'en-US': 'English',
  'zh-TW': '繁體中文',
};

export const NAMESPACES = ['common', 'settings', 'trade', 'auth', 'dashboard', 'emotion', 'checklist', 'profile', 'support', 'reports', 'nav', 'about', 'help'] as const;

export type Namespace = (typeof NAMESPACES)[number];

export const DEFAULT_NAMESPACE: Namespace = 'common';

// 语言检测工具函数
export function matchLanguage(lang: string): SupportedLanguage {
  const normalized = lang.toLowerCase();
  
  if (normalized.startsWith('zh-tw') || normalized.startsWith('zh-hant') || normalized.startsWith('zh-hk')) {
    return 'zh-TW';
  }
  if (normalized.startsWith('zh')) {
    return 'zh-CN';
  }
  if (normalized.startsWith('en')) {
    return 'en-US';
  }
  
  return DEFAULT_LANGUAGE;
}
